var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('img',{attrs:{"src":require('@/assets/icons/errors/ico-'+_vm.error.icon+'.svg'),"alt":"error.icon"}})]),_c('p',[_vm._v(_vm._s(_vm.error.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }